import {IntermediatePart} from "../../intermediatePart";
import {SLAT_WALL_POSITIONS} from "../../constants";

export default class SlatWall extends IntermediatePart {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'slat_wall';
    this.partName = 'Slatwall';
    this.translateId = "visualizer.kitchen.walls.slat_wall";
    this.activeFeatureBeforeAllWalls = null;
    this.allWallsApplied = true;
    this.isStoneFeature = true;
    this.slatWallType = SLAT_WALL_POSITIONS[0];
    this.hasAdditionalParts = true;
  }

  load(dbFeature) {
    if (!dbFeature.metaData["Part"]) {
      dbFeature.metaData["Part"] = ["2"];
    }
    if (!dbFeature.metaData["Height"]) {
      dbFeature.metaData["Height"] = ["2"];
    }
    const isMainFeature = (dbFeature.metaData["Part"][0] === "2") && (dbFeature.metaData["Height"][0] === "2");
    return super.load_(dbFeature, new SlatWall(false, SlatWall),
      true, isMainFeature ? 'features' : 'featuresParts');
  }

  setActiveFeatureParts(fromFeature = this.activeFeature, activeFeatureConditions = []) {
    if (!fromFeature) {
      return []
    }
    const currentConditions = activeFeatureConditions || this.getArrayOfConditions();
    const name1 = fromFeature.getSplittedFeatureName();
    const parts = this.featuresParts.filter(attFeature => {
      if (!attFeature.matchesMetaForArrayOfConditions(currentConditions) || (name1 !== attFeature.getSplittedFeatureName())) {
        return false
      }
      switch (this.slatWallType) {
        case SLAT_WALL_POSITIONS[0]: // center horizontal
          return (attFeature.matchesMetaForCondition("Part", "1") && attFeature.matchesMetaForCondition("Height", "2"))
            || (attFeature.matchesMetaForCondition("Part", "3") && attFeature.matchesMetaForCondition("Height", "2"))
        case SLAT_WALL_POSITIONS[1]:
          return false // only one center feature
        case SLAT_WALL_POSITIONS[2]: // center vertical
          return (attFeature.matchesMetaForCondition("Part", "2") && attFeature.matchesMetaForCondition("Height", "1"))
            || (attFeature.matchesMetaForCondition("Part", "2") && attFeature.matchesMetaForCondition("Height", "3"))
        case SLAT_WALL_POSITIONS[3]:
          return true // full wall, all are matching
      }
    });
    console.log("parts", name1, parts);
    return parts
  }

  showLayerPositionsModal() {
    return true
  }
}
